import React, { Component } from "react";
import MaterialTable from "material-table";
import { withStyles, IconButton, Tooltip, Paper } from "@material-ui/core";
/* import Pagination from "@jll/pagination"; */
import Icon from "@jll/icon";
import { styles } from "./styles";
import { TableHeader } from "./tableHeader";
import { NavLink } from "react-router-dom";

import {
  tableStyle,
  tableOptions,
  tableIcons,
} from "../../../../Component/Table/tableCommonStyles";

import CustomMTableHeader from "../../../../Component/Table/CustomMTableHeader";
import Pagination from "../../../../Component/Pagination";

import CustomMTableRow from "../../../../Component/Table/CustomTableRow";
import CustomMTableCell from "../../../../Component/Table/CustomMTableCell";
import CustomMTableActions from "../../../../Component/Table/CustomMTableActions";
import { withTranslation } from "react-i18next";

class RecordTable extends Component {
  state = {
    pageSize: 0,
  };
  render() {
    const {
      classes,
      data,
      totalItemsCount,
      rowsPerPage,
      pageNumber,
      handlePagination,
      handleRowsPerPage,
      canView,
      t,
    } = this.props;

    return (
      <div className={classes.checksTableContainer}>
        <MaterialTable
          style={tableStyle}
          icons={tableIcons}
          elevation="0"
          options={tableOptions}
          isLoading={false}
          data={data}
          localization={{
            header: {
              actions: t("labels.common.table.actions"),
            },
            body: {
              emptyDataSourceMessage: t("labels.common.table.noRecordsFound"),
            },
          }}
          columns={TableHeader(this.props.t)}
          actions={[
            canView && {
              icon: "view",
              position: "row",
              onClick: () => {},
            },
          ]}
          components={{
            Container: (props) => <Paper {...props} elevation={0} />,
            Actions: (props) => <CustomMTableActions {...props} />,
            Action: (props) => {
              switch (props.action.icon) {
                case "view":
                  return props.data.canView ? (
                    <Tooltip
                      title={t("labels.records.table.actions.viewDetails")}
                      placement="bottom"
                    >
                      <NavLink to={`/viewRecord?id=` + props.data.id}>
                        <IconButton className={classes.actionIcons}>
                          <Icon
                            className="far fa-arrow-circle-right"
                            style={{ fontSize: 16 }}
                          />
                        </IconButton>
                      </NavLink>
                    </Tooltip>
                  ) : (
                    ""
                  );
                default:
                  return null;
              }
            },
            Header: (props) => <CustomMTableHeader {...props} />,
            Row: (props) => <CustomMTableRow {...props} />,
            Cell: (props) => <CustomMTableCell {...props} />,
          }}
        />

        <Pagination
          handleRowsPerPage={handleRowsPerPage}
          rowsPerPage={rowsPerPage}
          pageNumber={pageNumber}
          handlePagination={handlePagination}
          totalItemsCount={totalItemsCount}
        ></Pagination>
      </div>
    );
  }
}

export default withTranslation()(
  withStyles(styles, { withTheme: true })(RecordTable),
);
